import { ContentSummary } from "tds/contentSummary";
import { formatDueDate, isOverdue } from "./time";
import * as locales from "./locales";
import { getAssetsUrl } from "common/helpers";
import { I18n } from "@devforce/trailhead-client-locale";
import salesforceLogo from "../../../../public/images/salesforce-favicon.svg";

const i18n = new I18n({ helpers: locales });

export function generateDueDateHtml(assignment: ContentSummary["assignment"]) {
  if (!assignment) return "";
  const isAssignmentOverdue = assignment.dueDate
    ? !assignment.completed && isOverdue(assignment.dueDate)
    : false;
  const formattedDueDate =
    (assignment.dueDate && formatDueDate(assignment.dueDate)) || "";
  const dueDateLabel = isAssignmentOverdue
    ? i18n.t("helpers", "overdueLabel", { formattedDueDate })
    : i18n.t("helpers", "dueDateLabel", { formattedDueDate });
  return `
    <div class="due-date">
      <tds-badge ${
        isAssignmentOverdue && "variant='badge-error'"
      }>${dueDateLabel}</tds-badge>
    </div>
  `;
}

export function stripEstimatedTimeLeft(contentSummary: ContentSummary) {
  if (!contentSummary) return null;
  const { user, ...rest } = contentSummary ?? {};
  return {
    ...rest,
    user: {
      ...user,
      estimatedTimeLeft: null,
    },
  };
}

export function formatDueDateLabel(assignment: ContentSummary["assignment"]) {
  if (!assignment) return "";
  return assignment.dueDate ? formatDueDate(assignment.dueDate) : "";
}

export function generateAssignedByHtml(
  assignment: ContentSummary["assignment"]
) {
  if (!assignment) return "";
  const assignedByLabel = i18n.t("helpers", "assignedByLabel", {
    assignedBy: assignment.assignedBy,
  });
  return `
    <div class="assigned-by">
      <img class="logo" alt={labels.trailheadLogoAltText} src="${getAssetsUrl(
        salesforceLogo
      )}" />
      <span>${assignedByLabel}</span>
    </div>
  `;
}
